import * as types from "./enumActionTypes";
import initialState from "./enumInitialState";

export default function enumReducer(state = initialState, action) {
  switch (action.type) {
    case types.CLEAR_ENUMS: {
      return initialState;
    }
    case types.GET_ENUM: {
      let newData = {};
      newData[action.payload.name] = { query: action.query, fetching: true };
      return { ...state, ...newData };
    }
    case types.GET_ENUM_SUCCESS: {
      let newData = {};
      newData[action.payload.name] = {
        ...state[action.payload.name],
        loaded: true,
        fetching: false,
        items: action.payload.data,
      };
      return { ...state, ...newData };
    }
    default: {
      return state;
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/enums/enumReducer.js